// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"2d08c3b3","777":"eff9c3f6"}[chunkId] + ".chunk.js";
};